import React from "react";
import { Box, Typography, CircularProgress } from "@mui/material";
import { useTranslation } from "react-i18next";

const styles = {
  container: {
    display: "flex",
    flexDirection: "column",
    justifyContent: "center",
    alignItems: "center",
    padding: "16px",
    boxSizing: "border-box",
    height: "100%",
  },
  content: {
    display: "flex",
    flexDirection: "column",
    alignItems: "center",
    textAlign: "center",
    flex: 1,
    justifyContent: "center",
    width: "100%",
    maxWidth: "400px",
  },
  loadingSpinner: (theme: any) => ({
    width: "60px",
    height: "60px",
    marginBottom: "24px",
    color: theme.palette.primary.light,
  }),
  loadingText: {
    fontFamily: "IBM Plex Sans, sans-serif",
    fontWeight: 400,
    fontSize: "16px",
    lineHeight: "24px",
    textAlign: "center",
    color: "#7D8081",
    maxWidth: "320px",
  },
};

function LoadingStep() {
  const { t } = useTranslation();

  return (
    <Box sx={styles.container}>
      <Box sx={styles.content}>
        <CircularProgress sx={styles.loadingSpinner} />
        <Typography sx={styles.loadingText}>
          {t("book_location.parcel_placement.checking_lockers")}
        </Typography>
      </Box>
    </Box>
  );
}

export default LoadingStep; 